import { useDndContext } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import {
  getDndDropIndicator,
  isDndDropTarget,
} from '../../RequestProfileTabActivities.utils'

export function useRequestProfileTabActivitiesSortableItem({
  data,
  disabled,
  id,
  type,
}) {
  const {
    attributes,
    index,
    isDragging,
    isOver,
    isSorting,
    listeners,
    newIndex,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ data, disabled, id })

  const style = {
    transform: isSorting ? undefined : CSS.Transform.toString(transform),
    transition: isSorting ? undefined : transition,
    visibility: isDragging ? 'hidden' : undefined,
  }

  const { active } = useDndContext()

  const dropIndicator = isDndDropTarget({
    active,
    data,
    isDragging,
    isOver,
    isSorting,
    type,
  })
    ? getDndDropIndicator({ index, newIndex })
    : undefined

  return { attributes, dropIndicator, listeners, setNodeRef, style }
}
